import React, { useState, useEffect } from 'react'
import moment from 'moment'
import natsort from 'natsort'
import { Link } from 'react-router-dom'

import { config } from '../../../../config/index'

import { POST, newFetch } from '../../../../helpers/fetch'

import {
  toWeekInt,
  toWeekStartDate,
  toWeekEndDate,
  toWeekDaysArrayFull
} from '../../../../helpers/moment'
const { API_URL } = config

const ScheduleTab = ({
  activeDate,
  activeWeek,
  activeClient,
  activeSite,
  associate
}) => {
  const token = localStorage.getItem('token')
  const [associateSchedules, setAssociateSchedules] = useState([])
  const [totalHours, setTotalHours] = useState(0)

  const getWeekDaysSites = day => {
    return associateSchedules
      .filter(schedule => schedule.date === day.format('YYYY-MM-DD'))
      .map(item => item.site)
      .filter((value, index, self) => self.indexOf(value) === index)
  }

  const getWeekDaysShifts = day => {
    return associateSchedules
      .filter(schedule => schedule.date === day.format('YYYY-MM-DD'))
      .map(item => item.shift)
      .filter((value, index, self) => self.indexOf(value) === index)
  }

  const getWeekSchedule = () => {
    if (activeWeek.startDate && activeClient) {
      return toWeekDaysArrayFull(
        activeWeek.startDate,
        activeClient.start_day
      ).map((day, index) => (
        <tr key={index}>
          <td className="border-right">
            <strong>{day.format('dddd DD/M')}</strong>
          </td>
          <td className="border-right text-center">
            <div className="d-flex flex-column">
              {getWeekDaysSites(day).length > 0
                ? getWeekDaysSites(day).map(site => (
                  <Link to="/scheduler" key={site}>
                    <span className="badge rounded-pill bg-brand mb-1">
                      {site}
                    </span>
                  </Link>
                ))
                : 'NA'}
            </div>
          </td>
          <td className="text-center">
            {getWeekDaysShifts(day).length > 0
              ? getWeekDaysShifts(day)
                .map(shift => {
                  return shift !== null
                    ? shift
                      .split(/\s/)
                      .reduce(
                        (response, word) => (response += word),
                        ''
                      )
                    : 'S'
                })
                .sort(natsort())
                .join(', ')
              : 'NA'}
          </td>
        </tr>
      ))
    }
  }

  // Fetch Associate Schedule
  useEffect(() => {
    const fetchAssociateSchedule = async () => {
      let url = `${API_URL}/associate/${associate.id}/schedule`

      try {
        let response = await fetch(url, {
          mode: 'cors',
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8'
          }
        })

        let json = await response.json()

        if (response.ok) {
          let filtered = json.data.filter(
            schedule =>
              schedule.date >=
              toWeekStartDate(
                moment(activeDate),
                activeClient.start_day
              ).format('YYYY-MM-DD') &&
              schedule.date <=
              toWeekEndDate(
                moment(activeDate),
                activeClient.start_day
              ).format('YYYY-MM-DD')
          )

          if (filtered.length > 0) {
            setAssociateSchedules(filtered)
          }
        } else {
          console.log(response.message)
        }
      } catch (error) {
        console.log(error)
      }
    }

    fetchAssociateSchedule()
  }, [token, associate, activeClient, activeDate])

  useEffect(() => {
    const fetchTotalHours = async () => {
      let api_path = `/site/${activeSite.id}/associate/${associate.id}/totalWorkHours`
      let body = { date: moment(activeDate).format('YYYY-MM-DD') }
      let response = await newFetch(POST, api_path, body)

      if (response.success) {
        setTotalHours(response.data)
      } else {
        setTotalHours(0)
      }
    }

    if (activeSite && activeDate) fetchTotalHours()
  }, [associate, activeSite, activeDate])

  return (
    <div className="w-100 mt-4">
      <div className="table-responsive border rounded">
        <table className="table mb-0">
          <thead>
            <tr>
              <th className="border-top-0 border-right">
                Week {toWeekInt(activeWeek.startDate, activeClient.start_day)}
              </th>
              <th className="border-right text-center">Sites</th>
              <th className="border-top-0 text-center">Shift</th>
            </tr>
          </thead>
          <tbody>{getWeekSchedule()}</tbody>
        </table>
      </div>
      <div className="mt-3 fw-bold">
        Total Hours this week:{' '}
        <span className="text-brand">
          {totalHours}/
          {activeClient && activeClient.max_hours.length > 0
            ? activeClient.max_hours.find(
              week =>
                week.start_date ===
                moment(activeWeek.startDate).format('YYYY-MM-DD')
            )
              ? activeClient.max_hours.find(
                week =>
                  week.start_date ===
                  moment(activeWeek.startDate).format('YYYY-MM-DD')
              ).hours
              : 0
            : 0}
        </span>
      </div>
    </div>
  )
}

export default ScheduleTab
